import type { NetworkCasseDetail, NetworkCasseDetailSelectionParams } from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkCasseDetail = async (
  selection: NetworkCasseDetailSelectionParams,
): Promise<NetworkCasseDetail> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.comparableStoreIds?.length)
    params.comparableStoreIds = selection.comparableStoreIds.join(',')
  if (selection.categoryIds?.length) params.categoryIds = selection.categoryIds.join(',')
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.comparableStartDate) params.comparableStartDate = selection.comparableStartDate
  if (selection.comparableEndDate) params.comparableEndDate = selection.comparableEndDate

  const response = await gozokiApiWithAuth.get<NetworkCasseDetail>(
    '/stores/get-network-casse-detail',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
